exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blance-bgc[data-v-15793922] {\n  background-color: #f3f3f1;\n}\n.blance-padding[data-v-15793922] {\n  padding: 15px 0 10px;\n}\n", ""]);

// exports
